export const CheckMarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    className="h-3.5 w-3.5 text-white md:h-4 md:w-4"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    {...props}>
    <path
      fillRule="evenodd"
      d="M16.704 5.293a1 1 0 00-1.408-1.414L8.25 10.928 5.204 7.88a1 1 0 00-1.408 1.414l4 4a1 1 0 001.408 0l7.5-7.5z"
      clipRule="evenodd"
    />
  </svg>
);
